import { scrollEventToggle } from "./scroll-event-toggle";

export function header() {
  let win = window;
  let $win = $(win);
  let $body = $("body");
  let showMenuClass = "show-menu";
  const itemWithDrop = $(".nav").find(".menu-item-has-children");
  function createOpenCloseButton() {
    if (itemWithDrop.length > 0) {
      itemWithDrop.each((index, el) => {
        const link = $(el).find("> .menu-item-holder");
        if (link.find(".arrow").length === 0) {
          link.append("<button type='button' class='arrow icon-plus'></button>");
        }
      });
    }
  }

  $(document).ready(function () {
    let _scrollEventToggle = scrollEventToggle();

    $body.on("click", ".open-menu", function (e) {
      e.preventDefault();

      let isMenuOpen = $body.hasClass(showMenuClass);

      _scrollEventToggle[!isMenuOpen ? "disable" : "enable"](true);
      $body.toggleClass(showMenuClass);
    });
  });

  $win.on("scroll", function () {
    $body[(win.scrollY > 1 ? "add" : "remove") + "Class"]("scrolled");
  });

  $(".header .menu-item-has-children .menu-item-holder > a").on("click", function (e) {
      e.preventDefault()
      const el = $(this);
      if (el) {
      const itemNav = $(el).closest("li");
      itemNav.siblings().removeClass("show-drop");
      itemNav.toggleClass("show-drop");

      if ($win.width() < 1200) {
        itemNav.siblings().find(".nav-drop").slideUp();
        itemNav.find(".nav-drop").slideToggle();
      }
    } else if (itemWithDrop.hasClass("show-drop")) {
      itemWithDrop.removeClass("show-drop");

      if ($win.width() < 1200) {
        itemWithDrop.find(".nav-drop").slideUp();
      }
    }
  });
  createOpenCloseButton();
}



// WEBPACK FOOTER //
// ./assets/js/modules/header.js